// /Components/Admin/Credit/CreditTabs.jsx
import { useState } from "react";
import { Users, Landmark } from "lucide-react";
import CustomerUdhaariTable from "./CustomerUdhaariTable";
import OrderInvoices from "./OrderInvoices";
import "../../Inventory/Inventory/InventoryAccordion.css";

export default function CreditTabs({ userID }) {
  const [tab, setTab] = useState("UDHAARI"); // "UDHAARI" | "INVOICES"

  return (
    <div className="inv-industrial-wrap">
      {/* Header (Inventory-style) */}
      <div className="inv-industrial-head">
        <div className="inv-industrial-title">
          <h1 className="CreateCampaign">Credit & Invoices</h1>
          <div className="inv-industrial-sub">
            Manage customer udhaari and invoices in one place.
          </div>
        </div>

        {/* (Optional) Right side actions - add later if needed */}
        <div className="inv-industrial-actions"></div>
      </div>

      {/* Tabs (Inventory-style) */}
      <div className="inv-tabs">
        <button
          type="button"
          className={`inv-tab ${tab === "UDHAARI" ? "active" : ""}`}
          onClick={() => setTab("UDHAARI")}
        >
          <Users size={16} />
          Udhaari
        </button>

        <button
          type="button"
          className={`inv-tab ${tab === "INVOICES" ? "active" : ""}`}
          onClick={() => setTab("INVOICES")}
        >
          <Landmark size={16} />
          Invoices
        </button>
      </div>

      {/* Content */}
      {tab === "UDHAARI" ? (
        <CustomerUdhaariTable userID={userID} />
      ) : tab === "INVOICES" ? (
        <OrderInvoices userID={userID} />
      ) : (
        <>More Tabs Will Be Here</>
      )}
    </div>
  );
}
